import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { firestore } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";

const Wrap = styled.div`
  margin-top: 14px;
  border-radius: 18px;
  border: 1px solid #e5e7eb;
  background: #fff;
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

const HeaderRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border-bottom: 1px solid #f1f5f9;
`;

const HeadTitle = styled.div`
  font-weight: 900;
  color: #111827;
`;

const HeadNote = styled.div`
  font-size: 13px;
  color: #6b7280;
`;

const Track = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

const Lane = styled.div`
  display: flex;
  gap: 14px;
  align-items: center;
  padding: 14px 16px;

  /* pausar animation när man hovrar */
  &:hover {
    animation-play-state: paused;
  }
`;

const Pill = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;   /* 👈 CENTRERAR */
  gap: 10px;

  min-width: 220px;
  max-width: 220px;
  padding: 12px 14px;
  border-radius: 10px;
  text-decoration: none;

  border: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #ffffff, #fafafa);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
`;


const PillNoLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;   /* 👈 CENTRERAR */
  gap: 10px;

  min-width: 220px;
  max-width: 220px;
  padding: 12px 14px;
  border-radius: 10px;

  border: 1px solid #e5e7eb;
  background: linear-gradient(135deg, #ffffff, #fafafa);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
`;


const Logo = styled.img`
  width: 210px;
  height: 100px;
  object-fit: contain;
  display: block;
`;

const Name = styled.div`
  font-weight: 900;
  color: #111827;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Tag = styled.div`
  margin-left: auto;
  font-size: 12px;
  font-weight: 900;
  color: #0f766e;
  background: rgba(15, 118, 110, 0.10);
  border: 1px solid rgba(15, 118, 110, 0.18);
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
`;

const Skeleton = styled.div`
  height: 78px;
  background: linear-gradient(90deg, #f3f4f6, #fafafa, #f3f4f6);
  background-size: 200% 100%;
  animation: shimmer 1.1s infinite linear;

  @keyframes shimmer {
    0% { background-position: 0% 0; }
    100% { background-position: 200% 0; }
  }
`;

const SponsorsMarquee = ({ speedSeconds = 35 }) => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const snap = await getDocs(collection(firestore, "sponsors"));
        const sponsorList = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // sort: största först
        sponsorList.sort((a, b) => (b.paymentAmount || 0) - (a.paymentAmount || 0));
        setSponsors(sponsorList);
      } finally {
        setLoading(false);
      }
    };

    fetchSponsors();
  }, []);

  const tierOf = (amt) =>
    (amt || 0) >= 5000 ? "Guld" : (amt || 0) >= 2000 ? "Silver" : "Bron";

  // För att få “oändlig” känsla: duplicera listan
  const items = useMemo(() => {
    if (!sponsors.length) return [];
    const base = sponsors.slice(0, 20); // begränsa lite för smoothness
    return [...base, ...base];
  }, [sponsors]);

  if (loading) {
    return (
      <Wrap>
        <HeaderRow>
          <HeadTitle>Våra sponsorer</HeadTitle>
          <HeadNote>Laddar…</HeadNote>
        </HeaderRow>
        <Skeleton />
      </Wrap>
    );
  }

  if (!items.length) {
    return null;
  }

  return (
    <Wrap aria-label="Rullande sponsorlista">
      <HeaderRow>
        <HeadTitle>Våra sponsorer</HeadTitle>
        <HeadNote>Hovra för att pausa • Klicka för att besöka</HeadNote>
      </HeaderRow>

      <Track>
        <Lane
          style={{
            animation: `marquee ${speedSeconds}s linear infinite`,
          }}
        >
          {items.map((s, idx) => {
            const link = s.sponsorLink?.trim();
            const name = s.name || s.companyName || "Sponsor";
            const tag = tierOf(s.paymentAmount);

            const content = (
              <>
                <Logo src={s.imageUrl} alt={name} />
                
              </>
            );

            if (link) {
              return (
                <Pill
                  key={`${s.id}-${idx}`}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {content}
                </Pill>
              );
            }

            return <PillNoLink key={`${s.id}-${idx}`}>{content}</PillNoLink>;
          })}
        </Lane>

        {/* keyframes lokalt via styled-components global style */}
        <style>
          {`
            @keyframes marquee {
              0% { transform: translateX(0); }
              100% { transform: translateX(-50%); }
            }
          `}
        </style>
      </Track>
    </Wrap>
  );
};

export default SponsorsMarquee;



